const formatPrice = (price) => {
  if (!price) return '$0';
  const numStr = price.toString().replace(/,/g, '');
  const [whole, decimal] = numStr.split('.');
  const formattedWhole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return decimal ? `$${formattedWhole}.${decimal}` : `$${formattedWhole}`;
};

export default formatPrice; 